import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';

import { ROOT_URL, isVAK, isOLG } from '../../../actions/root_url';

import PriceFormatter from '../../Common/priceFormatter';
import CashFormatter from '../../Common/cashFormatter';
import CellFormatter from '../../Common/cellFormatter';
import DateFormatter from '../../AR/CustomerStatement/dateFormatter';


class VendorStatementDetailTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: props.rows,
      sortColumn: null,
      sortDirection: null,
    };
  }
  
  getRows = () => Data.Selectors.getRows(this.state);

  getSize = () => this.getRows().length;

  // Grid does not properly re-render when more than one row is updated at a time
  // Problem solved, for more info Refer to link:
  // https://github.com/adazzle/react-data-grid/issues/332
  rowGetter = i => JSON.parse(JSON.stringify(this.getRows()[i]));

  handleGridSort = (sortColumn, sortDirection) => {
    this.setState(prevState => ({
      ...prevState,
      sortColumn,
      sortDirection,
    }));
  }

  render() {
    // const columns = [
    //   {
    //       key: 'invoice_number',
    //       name: <Translate value="invoice_no" />,
    //       resizable: true,
    //       sortable: true,
    //       width: 100,
    //   },
    //   {
    //       key: 'invoice_date',
    //       name: <Translate value="invoice_date" />,
    //       resizable: true,
    //       sortable: true,
    //       width: 90,
    //       formatter: DateFormatter,
    //   },
    //   {
    //       key: 'due_date',
    //       name: <Translate value="due_date" />,
    //       resizable: true,
    //       sortable: true,
    //       width: 90,
    //       formatter: DateFormatter,
    //   },
    //   {
    //       key: 'payment_received_date',
    //       name: <Translate value="pmt_rcv_date" />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: DateFormatter,
    //       width: 90,
    //   },
    //   {
    //       key: 'ap_number',
    //       name: <Translate value="a"p_#' />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: CellFormatter,
    //       width: 100,
    //   },
    //   {
    //       key: 'invoice_amount',
    //       name: <Translate value="invoice_amount" />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: CashFormatter,
    //       width: 80,
    //   },
    //   {
    //       key: 'balance',
    //       name: <Translate value="invoice_balance" />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: CashFormatter,
    //       width: 80,
    //   },
    //   {
    //       key: 'payment_paid_amount',
    //       name: <Translate value="pmt_paid_amount" />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: CashFormatter,
    //       width: 80,
    //   },
    //   {
    //       key: 'remaining_balance',
    //       name: <Translate value="balance" />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: CashFormatter,
    //       width: 80,
    //       getRowMetaData: (row) => row,
    //   },
    //   {
    //       key: 'type',
    //       name: <Translate value="type" />,
    //       resizable: true,
    //       sortable: true,
    //       formatter: CellFormatter,
    //       width: 150,
    //   },
    // ];

    const columns = [
      {
        key: 'PostingDate',
        name: <Translate value="date" />,
        resizable: true,
        sortable: true,
        formatter: DateFormatter,
        width: 90,
      },
      {
        key: 'Title',
        name: <Translate value="title" />,
        resizable: true,
        sortable: true,
        width: 120,
      },
      {
        key: 'InvoiceNum',
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        formatter: ({ value }) => (
          <div
            style={{ width: '100%', height: '100%' }}
            onDoubleClick={() => {
              if (value.substring(0, 1) === 'P' && value.substring(0, 2) !== 'PR') {
                this.props.printWarehouseReceive(value);
              } else {
                alert("Cannot print this invoice");
              }
            }}
          >
            { value }
          </div>
        ),
        width: 100,
      },
      ...isOLG ? [
        {
          key: 'VendorInvoiceNum',
          name: <Translate value="vendor_invoice_no" />,
          resizable: true,
          sortable: true,
          width: 150,
          filterable: true,
        },] : [],
      ...isVAK ? [
        {
          key: 'Method',
          name: <Translate value="payment_method" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'BankAccount',
          name: <Translate value="account" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
      ]:[],
      {
        key: 'CheckNum',
        name: <Translate value="check_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: 'Amount',
        name: <Translate value="charges" />,
        resizable: true,
        sortable: true,
        formatter: CashFormatter,
        width: 80,
      },
      {
        key: 'Payment',
        name: <Translate value="credits" />,
        resizable: true,
        sortable: true,
        formatter: CashFormatter,
        width: 80,
      },
      {
        key: 'Balance',
        name: <Translate value="balance" />,
        resizable: true,
        sortable: true,
        formatter: CashFormatter,
        width: 80,
      },
    ];

    const { minHeight } = this.props;
    return (
      <div id="VendorStatementDetailTable-dataGrid1">
        <ReactDataGrid
          enableCellSelect
          onGridSort={this.handleGridSort}
          columns={columns}
          rowHeight={25}
          headerRowHeight={45}
          minHeight={minHeight || 150}
          rowGetter={this.rowGetter}
          rowsCount={this.getSize()}
        />
      </div>
    );
  }
}

export default VendorStatementDetailTable;



// WEBPACK FOOTER //
// ./master/jsx/components/AP/VendorStatement/vendorStatementDetailTable.jsx